module.exports = __webpack_public_path__ + "static/vip_flag.244d2a69.png";